var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-modal",
    {
      staticClass: "frequency-modal",
      class: { "frequency-modal--holiday-recurrence": _vm.holidayRecurrence },
      attrs: {
        "action-required": "",
        fullscreen: false,
        visible: _vm.showFrequencyModal,
        width: "600px",
      },
    },
    [
      _c(
        "frequency-modal-wrapper",
        _vm._g(
          _vm._b(
            {
              on: {
                close: _vm.close,
                holidayRecurrence: function ($event) {
                  _vm.holidayRecurrence = $event
                },
              },
            },
            "frequency-modal-wrapper",
            _vm.$props,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }